import { Panel, Button } from 'react-bootstrap';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';


import '../../Assets/Ui/RequestCounter.css';

import { rqState } from '../../Constants.jsx';
import { LANG_FILTER_OPTIONS } from '../../Services/patientLang.js';
import { MARKET_FILTER_OPTIONS } from '../../Services/phoneCountry.js';

const sourceState = [
    { value: 'google', label: 'Google' },
    { value: 'bing', label: 'Bing' },
    { value: 'crechmed', label: 'Crechmed' },
    { value: 'infirmiers', label: 'Infirmiers' },
    { value: 'chatgpt', label: 'Chatgpt' },
    { value: 'amezian', label: 'Amezian' },
    { value: 'feeli-blog', label: 'Blog Feeli' },
    { value: 'skycall', label: 'Skycall (tous)' },
    { value: 'skycall-normal', label: 'Skycall (sauf skycall voice)' },
    { value: 'skycall-api', label: 'Skycall Api' },
    { value: 'skycall-voice', label: 'Skycall Voice' },
    { value: 'pharmacy', label: 'Pharmacie/Camping' },
    { value: 'null', label: 'Aucun source' }
];

const pathologyState = [
    { value: 'acne', label: 'acne' },
    { value: 'asthme', label: 'asthme' },
    { value: 'cardiologie', label: 'cardiologie' },
    { value: 'conjonctivite', label: 'conjonctivite' },
    { value: 'contraception', label: 'contraception' },
    { value: 'covid19', label: 'covid19' },
    { value: 'cystite', label: 'cystite' },
    { value: 'dentiste', label: 'dentiste' },
    { value: 'dermatologie', label: 'dermatologie' },
    { value: 'douleurs-de-dos', label: 'douleurs-de-dos' },
    { value: 'dysfonctionnement-erectile', label: 'dysfonctionnement-erectile' },
    { value: 'generaliste', label: 'generaliste' },
    { value: 'gynecologie', label: 'gynecologie' },
    { value: 'hemorroides', label: 'hemorroides' },
    { value: 'herpes', label: 'herpes' },
    { value: 'infection urinaire', label: 'infection urinaire' },
    { value: 'kit-voyage-et-vaccination', label: 'kit-voyage-et-vaccination' },
    { value: 'maladie-sexuelle', label: 'maladie-sexuelle' },
    { value: 'ophtalmologie', label: 'ophtalmologie' },
    { value: 'pediatrie', label: 'pediatrie' },
    { value: 'psychologie', label: 'psychologie' },
    { value: 'renouvellement-ordonnance', label: 'renouvellement-ordonnance' },
    { value: 'test-de-grossesse', label: 'test-de-grossesse' },
];
const createdTimeState = [
    { value: { start: new Date(new Date().getTime() - 1000*60*60).toISOString(), end: '' }, label: '< 1 heure' },
    { value: { start: new Date(new Date().getTime() - 1000*60*60*2).toISOString(), end: '' }, label: '< 2 heures' },
    { value: { start: new Date(new Date().getTime() - 1000*60*60*3).toISOString(), end: '' }, label: '< 3 heures' },
    { value: { start: '', end: new Date(new Date().getTime() - 1000*60*60*3).toISOString() }, label: '> 3 heures', },
];

const typeState = [
    { value: true, label: 'Urgent' },
    { value: false, label: 'Non urgent' },
];

const RequestCounter = ({ justToday, isPartner, count, countryLoad, loading, utm_source, onApply, setValues, isAdminFiscale, filterValue }) => {

    const handleDateChange = (e) => {
        setValues({ [e.target.name]: e.target.value || '' })
    };

    return (
        <Panel>
            <Panel.Heading>
                <h6>Compteur {justToday && new Date().toISOString().split('T')[0]} et filtre</h6>
            </Panel.Heading>
            <Panel.Body>
                <div className="counter">
                    <div className="filter-block">
                       { !justToday && (
                           <>
                            <div className="date-block">
                              <p>Debut</p>
                              <div className="inputDate">
                                <input  
                                    max={filterValue.end || new Date().toISOString().split('T')[0]}
                                    min={isAdminFiscale ? '2021-01-01' : ''}
                                    name="startDate" 
                                    onChange={handleDateChange} 
                                    type="date"
                                    value={filterValue.start}
                                />
                              </div>
                            </div>

                           <div className="date-block">
                            <p>Fin</p>
                            <div className="inputDate">
                                <input
                                    min={filterValue.start}
                                    max={isAdminFiscale ? '2023-10-31' : ''}
                                    name="endDate"   
                                    onChange={handleDateChange} 
                                    type="date" 
                                    value={filterValue.end}
                                />
                              </div>
                            </div>
                           </>
                       )}

                        <div className="select-group">
                            <div className="select-input">
                                <Select
                                    value={filterValue.type}
                                    onChange={(v) => {
                                        setValues({ type: v });
                                    }}
                                    options={rqState}
                                    isMulti
                                    styles={{ option: (s) => ({
                                        ...s,
                                        color: 'black'
                                    })}}
                                    role="checkbox"
                                    placeholder="Filtre par status ..." 
                                />
                            </div>

                            <div>
                                {
                                    !isPartner && !isAdminFiscale && 
                                    <div>
                                         &nbsp;
                                        <Select
                                            value={filterValue.createdTime}
                                            onChange={(v) => {
                                                setValues({ createdTime: v });
                                            }}
                                            options={createdTimeState}
                                            styles={{ option: (s) => ({
                                                ...s,
                                                color: 'black',
                                            })}}
                                            role="checkbox"
                                            isClearable
                                            placeholder="Filtre par temps ..." 
                                        />
                                        &nbsp;
                                        <Select
                                            value={filterValue.source}
                                            onChange={(v) => {
                                                setValues({ source: v });
                                            }}
                                            options={sourceState}
                                            styles={{ option: (s) => ({
                                                ...s,
                                                color: 'black',
                                            })}}
                                            role="checkbox"
                                            isClearable

                                            placeholder="Filtre par source ..." 
                                        />
                                        &nbsp;
                                        <Select
                                            value={filterValue.pathology}
                                            onChange={(v) => {
                                                setValues({ pathology: v });
                                            }}
                                            options={pathologyState}
                                            styles={{ option: (s) => ({
                                                ...s,
                                                color: 'black'
                                            })}}
                                            role="checkbox"
                                            placeholder="Filtre par pathologie ..." 
                                            isMulti
                                        />
                                        &nbsp;
                                        <AsyncSelect
                                            value={filterValue.pays}
                                            loadOptions={countryLoad}
                                            loadingMessage={() => <span className="loader" />}
                                            defaultOptions
                                            onChange={(e) => {
                                                setValues({ pays: e });
                                            }}
                                            styles={{ option: (s) => ({
                                                ...s,
                                                color: 'black'
                                            })}}
                                            role="checkbox"
                                            isClearable
                                            placeholder="Filtre par pays (d'apres le numero de telephone) ..." 
                                        />
                                         &nbsp;
                                        <Select
                                            value={filterValue.userLang}
                                            onChange={(e) => {
                                                setValues({ lang: e });
                                            }}
                                            options={LANG_FILTER_OPTIONS}
                                            styles={{ option: (s) => ({
                                                ...s,
                                                color: 'black'
                                            })}}
                                            role="checkbox"
                                            isClearable
                                            placeholder="Filtre par langue des utilisateurs ..." 
                                        />
                                         &nbsp;
                                        <Select
                                            value={filterValue.market}
                                            onChange={(e) => {
                                                setValues({ pool: e });
                                            }}
                                            options={MARKET_FILTER_OPTIONS}
                                            styles={{ option: (s) => ({
                                                ...s,
                                                color: 'black'
                                            })}}
                                            role="checkbox"
                                            isClearable
                                            placeholder="Filtre par marché ..." 
                                        />
                                    </div>
                                }
                                &nbsp;

                                <Select
                                    value={filterValue.priority}
                                    onChange={(v) => {
                                        setValues({ priority: v});
                                        
                                    }}
                                    options={typeState}
                                    styles={{ option: (s) => ({
                                        ...s,
                                        color: 'black',
                                    })}}
                                    role="checkbox"
                                    isClearable
                                    placeholder="Filtre par priorité ..." 
                                />

                                &nbsp;

                                {
                                    isPartner && utm_source === "skycall" && 
                                    <Select
                                    value={filterValue.source}
                                    onChange={(v) => {
                                        setValues({ source: v});
                                    }}
                                    options={[
                                        { value: null, label: 'Tous' },
                                        { value: 'skycall', label: 'Skycall (tous)' },
                                        { value: 'skycall-normal', label: 'Skycall (sauf skycall voice)' },
                                        { value: 'skycall-voice', label: 'Skycall Voice' },
                                        { value: 'skycall-api', label: 'Skycall Api' },
                                    ]}
                                    styles={{ option: (s) => ({
                                        ...s,
                                        color: 'black',
                                    })}}
                                    role="checkbox"
                                    placeholder="Filtre par source ..." 
                                />
                                }
                            </div>
                        </div>
                        <div>
                            <Button disabled={loading} onClick={onApply}>Appliquer</Button>
                        </div>
                    </div>

                    <div className="nb-block">
                        <Panel>
                            <Panel.Heading>
                                <h3>Total</h3>
                                {loading ? (
                                    <span className="loader" />
                                ) : (
                                    <h2>{count}</h2>
                                )}
                            </Panel.Heading>
                        </Panel>
                    </div>
                </div>
            </Panel.Body>
        </Panel>
    );
};

export default RequestCounter;
